import { render } from "./ApprovalHistory.vue?vue&type=template&id=03223dc0"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js"

import "./ApprovalHistory.vue?vue&type=style&index=0&id=03223dc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__